import React from 'react';
import { AccountContainer } from '../../account';
import { PrefixedReporterProvider } from '../../reporter';
import { MetaAttributes } from '../../head';
import { withSession } from '../../auth/serverSide';
import { withGladlySetting } from '../../gladly';
import {
  HEADLINE,
  SUBHEADLINE,
  DOG_SELECTOR_LABEL,
  ADD_PUP_BTN_LABEL,
  ADD_PUP_BTN_URL,
  YOUR_PUP,
  BLOGS,
} from '../../account/AccountContainer/constants';
import { LOGGEDIN_LINKS, LOGO_URL, LOGO_SR_TEXT } from '../../molecules';
import foodBowl from '../../images/FoodBowl.png';

const AccountPage = () => {
  return (
    <PrefixedReporterProvider prefix="MX">
      <MetaAttributes seoTitle={'Account Dashboard | Ollie'} />
      <AccountContainer
        headline={HEADLINE}
        subheadline={SUBHEADLINE}
        dogSelectorLabel={DOG_SELECTOR_LABEL}
        addPupBtnLabel={ADD_PUP_BTN_LABEL}
        addPupBtnUrl={ADD_PUP_BTN_URL}
        links={LOGGEDIN_LINKS}
        logoUrl={LOGO_URL}
        logoSrText={LOGO_SR_TEXT}
        yourPup={YOUR_PUP}
        discountAmount={40}
        learnMoreBtnLabel="Learn More"
        learnMoreHeading="What goes in Ollie products"
        learnMoreBody="100% real food, no by-products or funky fillers. We gently cook our food in small batches and deliver it for free to your door."
        learnMoreHref="/fresh-dog-food/"
        learnMoreImg={{
          src: foodBowl,
          alt: 'Food Bowl',
          height: 92,
          width: 100,
        }}
        blogs={BLOGS}
        blogHeading="From our blog"
        blogFontColor="hero.blueberry"
      />
    </PrefixedReporterProvider>
  );
};

/**
 * @type {import('next').GetServerSideProps}
 */
export const getServerSideProps = withGladlySetting(
  withSession(async () => {
    return {
      props: {},
    };
  }),
);
AccountPage.displayName = 'AccountPage';

AccountPage.propTypes = {};

export default AccountPage;
